module.exports = __webpack_public_path__ + "img/fail.835c1bef.png";